module.exports = __webpack_public_path__ + "img/jiamengBen.e5ef8281.png";